import { render, staticRenderFns } from "./TipoBem.vue?vue&type=template&id=5ffaf254"
import script from "./TipoBem.vue?vue&type=script&lang=js"
export * from "./TipoBem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports